import { useRef } from 'react'
import { CSSTransition, SwitchTransition } from 'react-transition-group'

import styles from './text-switch-transition.module.scss'

export type TextSwitchTransitionProps = {
  text: string
}

export const TextSwitchTransition = ({ text }: TextSwitchTransitionProps) => {
  const nodeRef = useRef<HTMLSpanElement | null>(null)
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={text}
        nodeRef={nodeRef}
        addEndListener={(done: () => void) => {
          nodeRef.current?.addEventListener('transitionend', done, false)
        }}
        classNames={{
          enter: `${styles.enter} ${styles.slide}`,
          enterActive: styles['enter--active'],
          enterDone: `${styles['enter--done']} ${styles.slide}`,
          exit: `${styles.exit} ${styles.slide}`,
          exitActive: styles['exit--active'],
          exitDone: `${styles['exit--done']} ${styles.slide}`,
        }}>
        <span ref={nodeRef}>{text}</span>
      </CSSTransition>
    </SwitchTransition>
  )
}
